import API from "../../../api.js";
import {
  ADMIN_APPTS_LIST_REQUEST,
  ADMIN_APPTS_LIST_SUCCESS,
  ADMIN_APPTS_LIST_FAIL,
  ADMIN_APPT_ASSIGN_REQUEST,
  ADMIN_APPT_ASSIGN_SUCCESS,
  ADMIN_APPT_ASSIGN_FAIL,
  ADMIN_APPT_REJECT_REQUEST,
  ADMIN_APPT_REJECT_SUCCESS,
  ADMIN_APPT_REJECT_FAIL,
  ADMIN_APPT_COMPLETE_REQUEST,
  ADMIN_APPT_COMPLETE_SUCCESS,
  ADMIN_APPT_COMPLETE_FAIL,
  ADMIN_APPT_REPORT_REQUEST,
  ADMIN_APPT_REPORT_SUCCESS,
  ADMIN_APPT_REPORT_FAIL,
  ADMIN_PAYMENT_REQUEST,
  ADMIN_PAYMENT_SUCCESS,
  ADMIN_PAYMENT_FAIL,
} from "../../constants/adminConstants/adminAppointmentConstants.js";
import { showToast } from "../../../components/ToastMessage.jsx";

// List appointments with optional filters
export const listAdminAppointments =
  (filters = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: ADMIN_APPTS_LIST_REQUEST });
      const params = new URLSearchParams(filters).toString();
      const { data } = await API.get(
        `/admin/appointments${params ? "?" + params : ""}`
      );
      dispatch({ type: ADMIN_APPTS_LIST_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: ADMIN_APPTS_LIST_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

// Assign doctor/date/time
export const assignAppointment = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_APPT_ASSIGN_REQUEST });
    const { data } = await API.put(`/admin/appointments/${id}/assign`, payload);
    dispatch({ type: ADMIN_APPT_ASSIGN_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({
      type: ADMIN_APPT_ASSIGN_FAIL,
      payload: error.response?.data?.message || error.message,
    });
    throw error;
  }
};

// Reject appointment
export const rejectAppointment = (id, reason) => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_APPT_REJECT_REQUEST });
    const { data } = await API.put(`/admin/appointments/${id}/reject`, {
      reason,
    });
    dispatch({ type: ADMIN_APPT_REJECT_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({
      type: ADMIN_APPT_REJECT_FAIL,
      payload: error.response?.data?.message || error.message,
    });
    throw error;
  }
};

// Complete appointment
export const completeAppointment = (id) => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_APPT_COMPLETE_REQUEST });
    const { data } = await API.put(`/admin/appointments/${id}/complete`);
    dispatch({ type: ADMIN_APPT_COMPLETE_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({
      type: ADMIN_APPT_COMPLETE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
    throw error;
  }
};

// Get report
export const fetchAppointmentReport = (params) => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_APPT_REPORT_REQUEST });
    const query = new URLSearchParams(params).toString();
    const { data } = await API.get(`/admin/appointments/report?${query}`);
    dispatch({ type: ADMIN_APPT_REPORT_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: ADMIN_APPT_REPORT_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Record payment (fixed bug: use appointmentId param)
export const recordPayment =
  (appointmentId, feePaid, method = "cash") =>
  async (dispatch) => {
    try {
      dispatch({ type: ADMIN_PAYMENT_REQUEST });
      const { data } = await API.put(
        `/admin/appointments/${appointmentId}/print-payment`,
        { feePaid, method }
      );
      dispatch({ type: ADMIN_PAYMENT_SUCCESS, payload: data });
      return data;
    } catch (err) {
      dispatch({
        type: ADMIN_PAYMENT_FAIL,
        payload: err.response?.data?.msg || err.message,
      });
      showToast(err.response?.data?.msg || err.message, "error");
      throw err;
    }
  };
